<template>
  <div>
    <!-- banner -->
    <el-carousel height="calc(var(--vw) * 952px)" :interval="3000" arrow="always">
      <el-carousel-item>
        <div style="position: relative;">
          <img v-if="$i18n.locale == 'zh'" class="image1" src="@/assets/home/image6.png" alt="">
          <img v-if="$i18n.locale == 'en'" class="image1" src="@/assets/home/image6_en.png" alt="">
          <!-- <div :class="`${className1} bannerFont`">国内领先和可信赖的汽车智能网联产品和技术服务合作伙伴</div> -->
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div style="position: relative;">
          <img v-if="$i18n.locale == 'zh'" class="image1" src="@/assets/home/image5.png" alt="">
          <img v-if="$i18n.locale == 'en'" class="image1" src="@/assets/home/image5_en.png" alt="">
          <!-- <div :class="`${className1} bannerFont`">国内领先和可信赖的汽车智能网联产品和技术服务合作伙伴</div> -->
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div style="position: relative;">
          <img v-if="$i18n.locale == 'zh'" class="image1" src="@/assets/home/image4.png" alt="">
          <img v-if="$i18n.locale == 'en'" class="image1" src="@/assets/home/image4_en.png" alt="">
          <!-- <div :class="`${className1} bannerFont`">国内领先和可信赖的汽车智能网联产品和技术服务合作伙伴</div> -->
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- 产品中心 -->
    <div class="chanpin">
      <div :class="`${className2} title`"><span ref="homeBox2">{{ $t('导航.首页.产品中心.产品中心') }}</span></div>
      <div class="chanpinBox">
        <div class="chanpinList" @click="tiao(0)" ref="homeBox3" :class="className3">
          <img src="@/assets/home/image7.png" alt="">
          <div class="right">
            <div class="rightTitle">{{ $t('导航.产品服务.车身电子') }}</div>
            <div class="desc">{{ $t('导航.产品服务.车身电子desc') }}</div>
          </div>
        </div>
        <div ref="homeBox3" @click="tiao(1)" class="chanpinList" :class="className3">
          <img src="@/assets/home/image8.png" alt="">
          <div class="right">
            <div class="rightTitle">{{ $t('导航.产品服务.智能座舱') }}</div>
            <div class="desc">{{ $t('导航.产品服务.智能座舱desc') }}</div>
          </div>
        </div>
        <div ref="homeBox4" @click="tiao(2)" class="chanpinList" :class="className4">
          <img src="@/assets/home/image9.png" alt="">
          <div class="right">
            <div class="rightTitle">{{ $t('导航.产品服务.智能驾驶') }}</div>
            <div class="desc">{{ $t('导航.产品服务.智能驾驶desc') }}</div>
          </div>
        </div>
        <div ref="homeBox4" @click="tiao(3)" class="chanpinList" :class="className4">
          <img src="@/assets/home/image10.png" alt="">
          <div class="right">
            <div class="rightTitle">{{ $t('导航.产品服务.车联网') }}</div>
            <div class="desc">{{ $t('导航.产品服务.车联网desc') }}</div>
          </div>
        </div>
        <!-- <div ref="homeBox5" class="chanpinList" :class="className5">
          <img src="@/assets/home/image11.png" alt="">
          <div class="right">
            <div class="rightTitle">域控</div>
            <div class="desc">智能前视摄像头、毫米波雷达、智能驾驶域控制器</div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- 生产和开发服务 -->
    <div class="fuwu">
      <div :class="`${className6} title`"><span ref="homeBox6">{{ $t('导航.生产开发服务') }}</span></div>
      <div class="fuwuBox">
        <div ref="homeBox7" @click="navi()" :class="`${className7} fuwuList`">
          <div style="display: flex;">
            <div class="paixu">01</div>
            <div class="right">
              <div class="rightTitle">{{ $t('导航.技术开发服务') }}</div>
              <div class="desc">{{ $t('导航.技术开发服务desc') }}</div>
            </div>
          </div>
          <img src="@/assets/home/image11.png" alt="">
        </div>
        <div ref="homeBox7" @click="navi()" :class="`${className7} fuwuList`">
          <div style="display: flex;">
            <div class="paixu">02</div>
            <div class="right">
              <div class="rightTitle">{{ $t('导航.生产制造') }}</div>
              <div class="desc">{{ $t('导航.生产制造desc') }}</div>
            </div>
          </div>
          <img src="@/assets/home/image12.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      className1: 'end',
      className2: 'end',
      className3: 'end',
      className4: 'end',
      className5: 'end',
      className6: 'end',
      className7: 'end'
    }
  },
  mounted() {
    setTimeout(() => {
      this.handleScroll()
      this.className1 = 'start'
    }, 100);
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    navi() {
      this.$emit('fuwuClick')
      window.scrollTo({
        top: 0
      })
      this.$router.push({
        name: 'Service'
      })
    },
    tiao(index) {
      localStorage.setItem('chanpinIndex', index) // 存储到本地存储，防止页面刷新返回初始状态
      this.$emit('chanpinClick', index)
      window.scrollTo({
        top: 0
      })
      this.$router.push({
        name: 'Product_Center'
      })
    },
    handleScroll() {
      if (this.$refs.homeBox2.getBoundingClientRect().top <= window.innerHeight) this.className2 = 'start'
      if (this.$refs.homeBox3.getBoundingClientRect().top <= window.innerHeight) this.className3 = 'start'
      if (this.$refs.homeBox4.getBoundingClientRect().top <= window.innerHeight) this.className4 = 'start'
      // if (this.$refs.homeBox5.getBoundingClientRect().top <= window.innerHeight) this.className5 = 'start'
      if (this.$refs.homeBox6.getBoundingClientRect().top <= window.innerHeight) this.className6 = 'start'
      if (this.$refs.homeBox7.getBoundingClientRect().top <= window.innerHeight) {
        this.className7 = 'start'
        window.removeEventListener('scroll', this.handleScroll)
      }
    }
  }

}
</script>
<style scoped lang="less">
.image1 {
  width: calc(var(--vw) * 1920px);
  height: calc(var(--vw) * 952px);
  display: block;
}

.bannerFont {
  width: calc(var(--vw) * 987px);
  position: absolute;
  left: calc(var(--vw) * 130.67px);
  top: calc(var(--vw) * 220.67px);
  font-weight: 600;
  font-size: calc(var(--vw) * 70px);
  color: #FFFFFF;
  text-align: left;
}

.fuwu {
  width: calc(var(--vw) * 1920px);
  height: calc(var(--vw) * 809px);
  display: block;
  background-repeat: no-repeat;
  background-image: url('@/assets/home/image3.png');
  background-size: 100%;

  .fuwuBox {
    padding: 0 calc(var(--vw) * 240.67px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .fuwuList {
      width: calc(var(--vw) * 644px);
      // height: calc(var(--vw) * 192px);
      background-color: #EDF3FF;
      border-radius: calc(var(--vw) * 21px);
      border: calc(var(--vw) * 2px) solid #FFFFFF;
      box-sizing: border-box;
      padding: calc(var(--vw) * 32px);
      margin-bottom: calc(var(--vw) * 32px);
      cursor: pointer;

      .paixu {
        width: calc(var(--vw) * 75px);
        height: calc(var(--vw) * 75px);
        background: #0F2B4C;
        border-radius: calc(var(--vw) * 21px);
        font-weight: 600;
        font-size: calc(var(--vw) * 37px);
        color: #FFFFFF;
        /* line-height: calc(var(--vw) * 43px); */
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: calc(var(--vw) * 32px);
      }

      img {
        width: calc(var(--vw) * 580px);
        height: calc(var(--vw) * 220px);
        margin-top: calc(var(--vw) * 30px);
      }

      .right {
        flex: 1;
        height: calc(var(--vw) * 150px);

        .rightTitle {
          font-weight: 600;
          font-size: calc(var(--vw) * 37px);
          color: #000000;
          text-align: left;
          display: block;
          box-sizing: content-box;
        }

        .desc {
          font-size: calc(var(--vw) * 21px);
          color: #000000;
          /* line-height: calc(var(--vw) * 32px); */
          text-align: left;
          opacity: 0.6;
          margin-top: calc(var(--vw) * 28px);
        }
      }
    }
  }
}

.title {
  text-align: center;
  font-weight: 600;
  font-size: calc(var(--vw) * 90px);
  color: #000000;
  padding: calc(var(--vw) * 90px) 0;
  transition: all 1s;
}

.chanpin {
  width: calc(var(--vw) * 1920px);
  height: calc(var(--vw) * 900px);
  display: block;
  background-repeat: no-repeat;
  background-image: url('@/assets/home/image2.png');
  background-size: 100%;

  .chanpinBox {
    padding: 0 calc(var(--vw) * 130.67px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .chanpinList {
      cursor: pointer;
      width: calc(var(--vw) * 803px);
      height: calc(var(--vw) * 224px);
      // box-shadow: inset 0px calc(var(--vw) * 41px) calc(var(--vw) * 160px) 0px rgba(35, 35, 35, 0.1);
      border-radius: calc(var(--vw) * 21px);
      border: calc(var(--vw) * 1px) solid #0F2B4C;
      box-sizing: border-box;
      padding: calc(var(--vw) * 32px);
      display: flex;
      margin-bottom: calc(var(--vw) * 32px);
      background-color: #fff;

      img {
        width: calc(var(--vw) * 327px);
        height: calc(var(--vw) * 160px);
        background: #484848;
        box-shadow: inset 0px calc(var(--vw) * 41px) calc(var(--vw) * 160px) 0px rgba(35, 35, 35, 0.1);
        border-radius: calc(var(--vw) * 21px);
        display: block;
        margin-right: calc(var(--vw) * 32px);
      }

      .right {
        flex: 1;
        position: relative;
        height: calc(var(--vw) * 160px);

        .rightTitle {
          font-weight: 600;
          font-size: calc(var(--vw) * 37px);
          color: #000000;
          text-align: left;
          display: block;
          position: absolute;
          left: 0;
          top: 0;
        }

        .desc {
          font-size: calc(var(--vw) * 21px);
          color: #000000;
          /* line-height: calc(var(--vw) * 32px); */
          text-align: left;
          opacity: 0.6;
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }
    }
  }
}
</style>
